import { render } from "./RowSquirrel.vue?vue&type=template&id=95af3522"
import script from "./RowSquirrel.vue?vue&type=script&lang=js"
export * from "./RowSquirrel.vue?vue&type=script&lang=js"

import "./RowSquirrel.vue?vue&type=style&index=0&id=95af3522&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__